<template>
    <div :class="keyboardClass"></div>
</template>

<script>
import Keyboard from "simple-keyboard";
import "simple-keyboard/build/css/index.css";

export default {
    name: "SimpleKeyboard",
    props: {
        keyboardClass: {
            default: "simple-keyboard",
            type: String
        },
        input: {
            type: String
        }
    },
    data: () => ({
        keyboard: null
    }),
    mounted() {
        this.keyboard = new Keyboard(this.keyboardClass, {
            onChange: this.onChange,
            onKeyPress: this.onKeyPress,
            layout: {
                default: [
                    "` 1 2 3 4 5 6 7 8 9 0 - + {bksp}",
                    "{tab} a z e r t y u i o p ^ $",
                    "{lock} q s d f g h j k l m \u00F9 * .",
                    "{shift} < w x c v b n . ; : ! {shift}",
                    "@ .com {space}",
                ],
                shift: [
                    "\u00B2 & \u00E9 \" ' ( - \u00E8 _ \u00E7 \u00E0 ) = {bksp}",
                    "{tab} A Z E R T Y U I O P \u00A8 \u00A3",
                    "{lock} Q S D F G H J K L M % \u00B5",
                    "{shift} > W X C V B N ? ? / \u00A7 {shift}",
                    "@ .com {space}",
                ],
            },
        });
    },
    methods: {
        onChange(input) {
            this.$emit("onChange", input);
        },
        onKeyPress(button) {
            this.$emit("onKeyPress", button);

            /**
             * If you want to handle the shift and caps lock buttons
             */
            if (button === "{shift}" || button === "{lock}") this.handleShift();
        },
        handleShift() {
            let currentLayout = this.keyboard.options.layoutName;
            let shiftToggle = currentLayout === "default" ? "shift" : "default";

            this.keyboard.setOptions({
                layoutName: shiftToggle
            });
        }
    },
    watch: {
        input(input) {
            this.keyboard.setInput(input);
        }
    }
};
</script>
